import { useCalendarAppointments } from "../../../../../../contexts/CalendarAppointmentsContext";
import CheckboxDropdown from "components/checkbox-dropdown/CheckboxDropdown";
import ColorCheckbox from "../../../color-checkbox/ColorCheckbox";
import messages from "messages";
import { AmplitudePageName, track } from "utils/amplitude";

interface AppointmentsToggleProps {
  analyticsPageName: AmplitudePageName;
}

const AppointmentsToggle = ({ analyticsPageName }: AppointmentsToggleProps) => {
  const { show, setShow } = useCalendarAppointments();

  return (
    <CheckboxDropdown
      Label={messages["11Sessions"]}
      onClick={() => {
        track(analyticsPageName, "1-to-1-sessions-toggle", "click");
        setShow(!show);
      }}
      Checkbox={
        <ColorCheckbox
          color={show ? "var(--deep-blue)" : "none"}
          backgroundColor={show ? "var(--secondary-blue)" : "none"}
          stroke={show ? "var(--secondary-blue)" : "var(--gray02)"}
        />
      }
    />
  );
};

export default AppointmentsToggle;
